import * as React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { context } from '../context';

// 直播内容的映射关系
const liveContentMap = {
    '': '全部',
    1: '才艺',
    2: '杂谈',
    3: '游戏',
    4: '综艺',
    5: '活动',
    6: '观影',
    7: '特殊',
    8: '投稿',
    9: '歌回',
    10: '其它',
};

export const LiveContentSelector = () => {
    const { selectedContent, setSelectedContent } = React.useContext(context);

    const handleChange = (event) => {
        setSelectedContent(event.target.value);
    };

    return (
        <FormControl fullWidth size="small">
            <InputLabel 
                id="content-select-label"
                sx={{ 
                    fontSize: '0.875rem',
                    '&.Mui-focused': { color: 'primary.main' },
                }}
            >
                内容
            </InputLabel>
            <Select
                labelId="content-select-label"
                value={selectedContent}
                label="内容"
                onChange={handleChange}
                sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 0, 0, 0.1)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.light',
                    },
                    '& .MuiSelect-select': {
                        fontSize: '0.875rem',
                    },
                }}
            >
                {Object.entries(liveContentMap).map(([key, value]) => (
                    <MenuItem 
                        key={key} 
                        value={key}
                        sx={{
                            fontSize: '0.875rem',
                            py: 1,
                            borderRadius: '6px',
                            mx: 0.5,
                            my: 0.25,
                        }}
                    >
                        {value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};